import React from 'react';
import { UIPicture } from '../components/basic';
import { UIVoiceoverBtn, UISoundBtn } from '../components/composite';
import { InfoDL } from './InfoComponents';
import Utils from '../../_Utils';

export const renderCommonInfo = ({ type, data, lang, handleVOStateChange, getText, isVoiceoverEnabled }) => 
{
    let year_title_key, year_data_key;
    let address_title_key, address_data_key;

    if (type === 'tatemono')
    {
        year_title_key = 'built';
        year_data_key = 'built';
        address_title_key = 'former-location';
        address_data_key = 'address';
    }
    else if (type === 'exterior')
    {
        year_title_key = 'period';
        year_data_key = 'period';
        address_title_key = 'former-location';
        address_data_key = 'address';
    }

    return (
        <>
            {data.description_filename && isVoiceoverEnabled() && (
                <UIVoiceoverBtn lang={lang} filename={data.description_filename} onStateChange={() => handleVOStateChange(getText('overview'))} />
            )}
            <div className="block info">
                <>
                    {data.is_construction && (
                        <div className="alert-message">
                            <p className="construction">
                                {getText('is-construction')}
                            </p>
                        </div>
                    )}
                    {(data.collection || data.designation) && (
                        <dl className="info-item">
                            <dd>
                                {data.designation && (
                                    <div className="label-item designation">
                                        <p className="icon designation"></p>
                                        {data.designation}
                                    </div>
                                )}
                                {data.collection && (
                                    <div className="label-item collection">
                                        <p className="icon collection"></p>
                                        {data.collection}
                                    </div>
                                )}
                            </dd>
                        </dl>
                    )}
                    {data[year_data_key] && String(data[year_data_key]).trim() && (
                        <InfoDL title={getText(year_title_key)}>{data[year_data_key]}</InfoDL>
                    )}
                    {data[address_data_key] && String(data[address_data_key]).trim() && (
                        <InfoDL title={getText(address_title_key)}>
                            <span dangerouslySetInnerHTML={{ 
                                __html: Utils.styleChars(data[address_data_key], lang)
                            }} />
                        </InfoDL>
                    )}
                    {data.description && String(data.description).trim() && (
                        <InfoDL title={getText('description')}>
                            <div className="block text-block" dangerouslySetInnerHTML={{ __html: Utils.markdownToHtml(data.description) }} />
                        </InfoDL>
                    )}
                </>
            </div>
        </>
    );
};

export const renderHighlights = ({ type, data, lang, handleVOStateChange, getText }) => 
{
    const highlights = [];
    
    for (let bi = 1; bi <= 4; bi++)
    {
        const hlTextKey = `hl${bi}`;
        const hlImgKey = `hl${bi}_img`;
        const hlImgCaptionKey = `hl${bi}_img_caption`;
        
        const hlText = data[hlTextKey];
        let hlImgID = data[hlImgKey];
        const hlImgCaption = data[hlImgCaptionKey];

        if (hlText)
        {
            let img_src = '';
            let hlImgDir = 'h';

            if (hlImgID)
            {
                let m = (hlImgID + '').match(/(\d+)([a-zA-Z])?/);

                if (m && m[2])
                {
                    hlImgID = parseInt(m[1]);
                    hlImgDir = m[2];
                } 

                // Generate different paths based on type
                if (type === 'tatemono')
                {
                    const z_id = String(data.zone_site_id).padStart(2, '0');
                    img_src = `${process.env.PUBLIC_URL}/img/tatemono/tatemono_highlight_${data.zone}_${z_id}_${bi}_${hlImgID}.jpg`;
                }
                else if (type === 'exterior')
                {
                    img_src = `${process.env.PUBLIC_URL}/img/exterior/exterior_highlight_${data.id}_${bi}_${hlImgID}.jpg`;
                }
            }

            highlights.push(
                <div key={`highlight-${bi}`} className="block text-block highlight-info">
                    {hlImgID &&
                        <figure>
                            <UIPicture 
                                src={img_src} 
                                alt="" 
                                className={`protected img-${hlImgDir}`}
                            />
                            {hlImgCaption && <figcaption>{hlImgCaption}</figcaption>}
                        </figure>
                    }
                    <div className="block text-block highlight" 
                        dangerouslySetInnerHTML={{ __html: Utils.markdownToHtml(hlText) }} 
                    />
                </div>
            );
        }
    }
    
    return highlights;
};

export const generateSimulationContent = ({ data, lang, getText }) =>
{
    let items = [];
    
    for (let i = 1; i <= 3; i++)
    {
        const imgKey = `sim_img${i}`;
        const audioKey = `sim_audio${i}`;
        const descKey = `sim_description${i}`;
        
        if (data[imgKey])
        {
            const imgSrc = `${process.env.PUBLIC_URL}/img/simulations/${data[imgKey]}.jpg`;
            const description = data[descKey];
            
            items.push(
                <div key={i} className="sound-item" data-id={i}>
                    <UIPicture
                        src={imgSrc}
                        className="item-image"
                    />
                    <div className="item-description">
                        <p dangerouslySetInnerHTML={{ 
                            __html: Utils.styleChars(
                                Utils.markdownToHtml(description || ''),
                                lang
                            )
                        }} />
                    </div>
                    {data[audioKey] && (
                        <UISoundBtn
                            filename={`simulations/${data[audioKey]}`}
                            className="simulation"
                        />
                    )}
                </div>
            );
        }
    }

    return (
        <div className="block simulation">
            <h3 className="block-title">
                {getText('simulation-lead')}
            </h3>
            {items}
        </div>
    );
}; 